"use client";

import Script from "next/script";

const googleTagId = process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS_ID as string;
const isProduction = process.env.NODE_ENV === "production";

// Add gtag to window type
declare global {
	interface Window {
		gtag: (...args: any[]) => void;
		dataLayer: any[];
	}
}

export function AnalyticsScript() {
	if (!isProduction) {
		return null;
	}

	// 桩随 HTML 同步执行（js/config 调用先进 dataLayer 队列），外部 gtag.js 等
	// 页面 load 后空闲时再拉，把它的执行移出 hydration 窗口；gtag.js 加载后
	// 会消费队列，pageview 不丢。useAnalytics 只检查 window.gtag 存在与否。
	return (
		<>
			<script
				id="google-analytics-stub"
				// biome-ignore lint/security/noDangerouslySetInnerHtml: 静态桩，googleTagId 来自构建期环境变量
				dangerouslySetInnerHTML={{
					__html: `window.dataLayer=window.dataLayer||[];function gtag(){window.dataLayer.push(arguments);}window.gtag=gtag;gtag('js',new Date());gtag('config','${googleTagId}');`,
				}}
			/>
			{/* Google tag (gtag.js) */}
			<Script
				strategy="lazyOnload"
				src={`https://www.googletagmanager.com/gtag/js?id=${googleTagId}`}
			/>
		</>
	);
}

export function useAnalytics() {
	const trackEvent = (event: string, data?: Record<string, unknown>) => {
		if (!isProduction || typeof window === "undefined" || !window.gtag) {
			return;
		}

		window.gtag("event", event, data);
	};

	return {
		trackEvent,
	};
}
